import { defineStore } from 'pinia'
import { type WalletOption, connectWallet, disconnectWallet, generateWallets } from '@/wallets'
import type { MintheClient } from 'libminthe/libminthe'
import { useRoute } from 'vue-router'


export const useStore = defineStore('main', {
  state: () => ({
    debug: true,
    route:useRoute(),
    isInitialized: false,
    wallets: generateWallets(true) as WalletOption[],
    activate_wallet: undefined as WalletOption|undefined,
    show_wallet_model:false,
    wallet_public_key:"",
    mint_running:false,
    minthe_context:undefined as MintheClient|undefined,
    use_invite_code:""
  }),

  actions: {
    async clickSwitchWallet(wallet:WalletOption){
      if(this.mint_running){
        return
      }
      console.log("clickSwitchWallet")
      if(wallet.adapter.connected&&wallet.adapter.publicKey){
        this.activate_wallet = wallet
        return
      }
      try{
        await connectWallet(wallet)
        if(wallet.adapter.connected){
          this.activate_wallet = wallet
          this.show_wallet_model = false
        }

      }catch(e:any){
        alert(`Error:${e}`)
      }
    },
    async clickdisconnectWallet(wallet:WalletOption){
      if(this.mint_running){
        return
      }
      console.log("disconnect")
      try{
        this.activate_wallet = undefined
        await disconnectWallet(wallet)
      }catch(e:any){
        alert(`Error:${e}`)
      }
    }
  },

  getters: {

  },
})
